/**
 * A/B Test — Travel Set horizontal bundle layout
 * Products: /products/weekender + /products/backpack
 *
 * Toggle: body[data-bundle-horizontal-ab="true|false"]
 *   Weekender:
 *     - false: vertical stack (bundle still shown via data-bundle-selector-ab)
 *     - true: horizontal layout
 *   Backpack:
 *     - false: hide custom bundle entirely → original static PDP
 *     - true: show custom Overpacker bundle (horizontal)
 *
 * Intelligems-safe: no attribute writes, no MutationObserver, no body mutations.
 * Dev preview: ?bundle_horizontal_test=b on weekender or backpack PDP
 */
(function () {
  'use strict';

  if (window.__bundleHorizontalAbInit) return;
  window.__bundleHorizontalAbInit = true;

  var ACTIVE_CLASS = 'bundle-horizontal-ab--active';

  function isEligiblePdp() {
    var path = String(location.pathname || '').toLowerCase();
    return (
      path.indexOf('/products/weekender') > -1 ||
      path.indexOf('/products/aerless-weekender') > -1 ||
      path.indexOf('/products/backpack') > -1 ||
      path.indexOf('/products/aerless-backpack') > -1
    );
  }

  function isDevVariantB() {
    try {
      var v = new URLSearchParams(window.location.search).get('bundle_horizontal_test');
      return v === 'b' || v === 'true' || v === '1';
    } catch (e) {
      return false;
    }
  }

  // Production: CSS handles body[data-bundle-horizontal-ab="true"] + eligible class.
  if (!isDevVariantB() || !isEligiblePdp()) return;

  function enableDevPreview() {
    document.documentElement.classList.add(ACTIVE_CLASS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enableDevPreview);
  } else {
    enableDevPreview();
  }
})();
